var React = require('react');

function SubmitArrowDesktop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M39.5 2C39.5 1.17157 38.8284 0.5 38 0.499999L24.5 0.500001C23.6716 0.499999 23 1.17157 23 2C23 2.82843 23.6716 3.5 24.5 3.5L36.5 3.5L36.5 15.5C36.5 16.3284 37.1716 17 38 17C38.8284 17 39.5 16.3284 39.5 15.5L39.5 2ZM3.06066 39.0607L39.0607 3.06066L36.9393 0.939339L0.93934 36.9393L3.06066 39.0607Z","fill":"#E3232A"}));
}

SubmitArrowDesktop.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = SubmitArrowDesktop;

SubmitArrowDesktop.default = SubmitArrowDesktop;
